import { useSyncExternalStore } from "react";

const KEY = "ep-theme";
const isLight = () => document.documentElement.classList.contains("light");

export const setTheme = (theme) => {
  document.documentElement.classList.toggle("light", theme === "light");
  localStorage.setItem(KEY, theme);
  window.dispatchEvent(new Event("ep-theme"));
};

const subscribe = (cb) => {
  window.addEventListener("ep-theme", cb);
  return () => window.removeEventListener("ep-theme", cb);
};

export const useTheme = () => (useSyncExternalStore(subscribe, isLight) ? "light" : "dark");
